import router from './router'
import store from './store'
import storage from 'store'
import NProgress from 'nprogress' // progress bar
import '@/components/NProgress/nprogress.less' // progress bar custom style
import notification from 'ant-design-vue/es/notification'
import { setDocumentTitle, domTitle } from '@/utils/domUtil'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { i18nRender } from '@/locales'
import { setErpOpenApiSourceMenu } from '@/utils/erpOpenApiContext'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const allowList = ['login', 'register', '/callback', '/auth-redirect', '/bind'] // no redirect allowList
const loginRoutePath = '/user/login'
const defaultRoutePath = '/index'

function sanitizeRedirect (redirect) {
  if (!redirect || typeof redirect !== 'string') return defaultRoutePath
  const path = redirect.trim()
  if (!path.startsWith('/') || path.startsWith('//')) return defaultRoutePath
  if (path === loginRoutePath || path.startsWith(loginRoutePath + '?') || path === '/404') {
    return defaultRoutePath
  }
  return path
}

/** 把 /a/b?x=1#y 转成 router 可识别的 location，避免把 query 写进 path */
function toRouteLocation (redirect, replace) {
  const safe = sanitizeRedirect(redirect)
  try {
    const url = new URL(safe, window.location.origin)
    const query = {}
    url.searchParams.forEach((value, key) => { query[key] = value })
    return { path: url.pathname, query, hash: url.hash, replace: !!replace }
  } catch (e) {
    return { path: defaultRoutePath, replace: !!replace }
  }
}

function ensureDynamicRoutes (to, next, preferRedirect) {
  if (store.getters.roles.length !== 0) {
    if (preferRedirect) {
      next(toRouteLocation(preferRedirect, true))
    } else {
      next()
    }
    return
  }
  store
    .dispatch('GetInfo')
    .then(res => {
      const roles = res.roles
      return store.dispatch('GenerateRoutes', { roles }).then(() => {
        const addRouters = store.getters.addRouters || []
        if (addRouters.length) {
          router.addRoutes(addRouters)
        }
        if (preferRedirect) {
          next(toRouteLocation(preferRedirect, true))
        } else {
          // hack：确保 addRoutes 已完成后再进入目标页
          next({ ...to, replace: true })
        }
      })
    })
    .catch(() => {
      notification.error({
        message: '错误',
        description: '请求用户信息失败，请重试'
      })
      store.dispatch('Logout').finally(() => {
        next({ path: loginRoutePath, replace: true })
        NProgress.done()
      })
    })
  store.dispatch('getCity')
}

router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar
  to.meta && (typeof to.meta.title !== 'undefined' && setDocumentTitle(`${i18nRender(to.meta.title)} - ${domTitle}`))
  /* has token */
  if (storage.get(ACCESS_TOKEN)) {
    if (to.path === loginRoutePath || to.path === '/') {
      const target = sanitizeRedirect(to.query && to.query.redirect)
      ensureDynamicRoutes(to, next, target)
      NProgress.done()
    } else {
      ensureDynamicRoutes(to, next)
    }
  } else {
    if (allowList.includes(to.name)) {
      // 在免登录名单，直接进入
      next()
    } else {
      next({ path: loginRoutePath, query: { redirect: to.fullPath } })
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach((to) => {
  NProgress.done() // finish progress bar
  const matched = (to.matched || []).filter(r => r.meta && r.meta.title)
  const title = matched.length ? matched[matched.length - 1].meta.title : (to.meta && to.meta.title) || ''
  setErpOpenApiSourceMenu(title)
})
